import React from "react";
import AccountingReports from "../../features/accountingreports";

const AccountingReportsPage = () => <AccountingReports />

export default AccountingReportsPage;